export const FEATURES = {
  ENABLE_TRANSACTION_SEARCH: false,
  ENABLE_ALL_ACCOUNTS: false,
  ENABLE_PAYMENT_TABS: true,
  ENABLE_PORTFOLIO: false,
};
